import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const WorkflowDeleteDialog = ({
  isDeleteDialogOpen,
  setIsDeleteDialogOpen,
  setDeletingWorkflowId,
  handleDeleteWorkflow,
}) => {
  const { t } = useTranslation();
  return (
  <AlertDialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{t('approvalComp.deleteTitle')}</AlertDialogTitle>
        <AlertDialogDescription>
          {t('approvalComp.deleteDesc')}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={() => { setIsDeleteDialogOpen(false); setDeletingWorkflowId(null); }}>
          {t('common.cancel')}
        </AlertDialogCancel>
        <AlertDialogAction onClick={handleDeleteWorkflow}>{t('common.delete')}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  );
};

export default WorkflowDeleteDialog;
